export const STATE_IDENTIFIER = {
  NUM_TASK: "numTask",
  NUM_APPROVAL: "numApproval",
  NOTIFY_MSG: "notificationMsg",
}